import React, { Component } from 'react';
import "./Header.scss";

export default class Header extends Component {
  render() {
    return (
      <div>
        <header _ngcontent-c0="" aria-hidden="false" class="l-header  l-header--concierge" data-view="responsive/PrimaryNav" id="main-header" role="banner" style={{ height: "initial" }}>
          
          <div _ngcontent-c0="" class="l-header__top-strip" style={{ backgroundColor: '#f5f5f5', fontFamily: 'Nobel Book,helvetica,arial,roboto,sans-serif' }}>
            <div _ngcontent-c0="" class="l-top-strip js-topStrip">
              <div _ngcontent-c0="" class="l-top-strip__cta-list">
                <nav _ngcontent-c0="" aria-label="Top Nav" class="c-top-cta-list   js-topCta-bar" role="navigation">
                  <ul _ngcontent-c0="" class="c-top-cta-list__inner">
                    <li _ngcontent-c0="" class="c-top-cta-list__item">
                      <a _ngcontent-c0="" class="c-top-cta-list__link" data-overlay-native-form="true" data-view="responsive/Overlay" id="testdrive" target="_blank" href="https://www.lexusauto.es/formulario/prueba-conduccion">Solicite una Prueba de Conducción</a>
                    </li>
                    <li _ngcontent-c0="" class="c-top-cta-list__item">
                      <a _ngcontent-c0="" class="c-top-cta-list__link" data-overlay-native-form="true" data-view="responsive/Overlay" id="retailer" target="_blank" href="https://estilolexus.lexusauto.es/catalogo/">Solicite Catálogo</a>
                    </li>
                    <li _ngcontent-c0="" class="c-top-cta-list__item">
                      <a _ngcontent-c0="" class="c-top-cta-list__link" data-overlay-native-form="true" data-view="responsive/Overlay" id="build" target="_blank" href="https://www.lexusauto.es/concesionarios">Concesionarios</a>
                    </li>
                    <li _ngcontent-c0="" class="js-contextualDealerLink"></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>

          <div _ngcontent-c0="" class="l-header__inner">
            <div _ngcontent-c0="" class="l-header__top-banner">
              <div _ngcontent-c0="" class="l-top-banner">
                <div _ngcontent-c0="" class="l-top-banner__inner">
                  <div _ngcontent-c0="" class="l-top-banner__logo">
                    <div _ngcontent-c0="" class="c-logo " itemscope="" itemtype="https://schema.org/Organization">
                      <a _ngcontent-c0="" href="https://www.lexusauto.es" id="lexus-logo" itemprop="url">
                        <meta itemprop="name" content="Lexus" />
                        {/* <img _ngcontent-c0="" alt="Lexus logo" class="c-logo__img" itemprop="logo" src="./images/lexus-logo.png" style={{ width: 140 }} /> */}
                        <img _ngcontent-c0="" alt="Lexus logo" class="c-logo__img" itemprop="logo" src="./images/lexus-logo2.svg" style={{ width: 140, height: 28 }} />
                      </a>
                    </div>
                  </div>
                  <div _ngcontent-c0="" class="l-top-banner__primary-nav">
                    <nav _ngcontent-c0="" aria-label="Primary" class="l-primary-nav l-primary-nav--compact" role="navigation">
                      <ul _ngcontent-c0="" class="l-primary-nav__list">
                        <li _ngcontent-c0="" class="l-primary-nav__list-item" style={{ marginTop: 0 }}>
                          <a _ngcontent-c0="" class="ui-primary-nav-button" target="_self" href="https://www.lexusauto.es/modelos" id="modelos">Modelos</a>
                        </li>
                        <li _ngcontent-c0="" class="l-primary-nav__list-item" style={{ marginTop: 0 }}>
                          <a _ngcontent-c0="" class="ui-primary-nav-button" target="_self" href="https://vo.lexusauto.es/" id="seminuevos">Seminuevos</a>
                        </li>
                        {/* <li _ngcontent-c0="" class="l-primary-nav__list-item" style={{ marginTop: 0 }}>
                          <a _ngcontent-c0="" class="ui-primary-nav-button" target="_self" href="https://www.lexusauto.es/electrified/" id="electrified"> Electrified </a>
                        </li> */}
                        <li _ngcontent-c0="" class="l-primary-nav__list-item" style={{ marginTop: 0 }}>
                          <a _ngcontent-c0="" class="ui-primary-nav-button" target="_self" href="https://www.lexusauto.es/promociones" id="promocion">Promociones</a>
                        </li>
                        <li _ngcontent-c0="" class="l-primary-nav__list-item" style={{ marginTop: 0 }}>
                          <a _ngcontent-c0="" class="ui-primary-nav-button" target="_self" href="https://www.lexusauto.es/electrified" id="electrified">Electrified</a>
                        </li>
                        <li _ngcontent-c0="" class="l-primary-nav__list-item" style={{ marginTop: 0 }}>
                          <a _ngcontent-c0="" class="ui-primary-nav-button" target="_self" href="https://www.lexusauto.es/business-plus" id="empresas">Empresas</a>
                        </li>
                        <li _ngcontent-c0="" class="l-primary-nav__list-item" style={{ marginTop: 0 }}>
                          <a _ngcontent-c0="" class="ui-primary-nav-button" target="_self" href="https://www.lexusauto.es/propietarios" id="propietarios">Propietarios</a>
                        </li>
                        <li _ngcontent-c0="" class="l-primary-nav__list-item" style={{ marginTop: 0 }}>
                          <a _ngcontent-c0="" class="ui-primary-nav-button" target="_self" href="https://www.lexusauto.es/descubra-lexus" id="descubra-lexus">Descubra Lexus</a>
                        </li>
                        <li _ngcontent-c0="" class="l-primary-nav__list-item" style={{ marginTop: 0 }}>
                          <a _ngcontent-c0="" class="ui-primary-nav-button" target="_self" href="https://www.lexusauto.es/estilolexus" id="blog">Blog</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div _ngcontent-c0="" class="l-top-banner__site-tools">
                    <nav _ngcontent-c0="" aria-label="Site tools" class="c-site-tools " role="navigation">
                      <ul _ngcontent-c0="" class="c-site-tools__list" style={{ marginTop: 3 }}>
                        <li _ngcontent-c0="" class="c-site-tools__item c-site-tools__item c-site-tools__item--my-lexus js-dropDown" data-view="responsive/MyLexusDropDown" style={{ marginTop: 0 }}>
                          {/* <button href="https://www.lexusauto.es/propietarios/acerca-de-my-lexus#/sso/login" _ngcontent-c0="" aria-expanded="false" class="c-site-tools__link js-dropDownButton" id="my-lexus">
                            <img _ngcontent-c0="" src="./images/login-user.png" style={{ width: 20, marginLeft: -30, marginRight: 8 }} />
                          </button> */}
                          {/* <div>

                          </div> */}
                          <a href="https://www.lexusauto.es/propietarios/acerca-de-my-lexus#/sso/login" _ngcontent-c0="" aria-expanded="false" class="c-site-tools__link js-dropDownButton" id="my-lexus" style={{ textDecoration: 'none' }}>
                            {/* <img _ngcontent-c0="" src="./images/login-user.png" style={{ width: 20, marginLeft: -30, marginRight: 8 }} /> */}
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                              <img _ngcontent-c0="" src="./images/login-user.png" style={{ width: 20, height: 20 }} />
                              <span className='tool-link-span'>Acceder</span>
                            </div>
                          </a>
                          {/* <span>Buscar</span> */}
                          {/* <div _ngcontent-c0="" aria-hidden="true" class="c-site-dropdown js-dropDownContent" id="user-login">
                            <a _ngcontent-c0="" class="c-site-dropdown__link" href="https://www.lexusauto.es/my-lexus/">
                              <div _ngcontent-c0="" class="c-site-dropdown__text"> INICIAR SESIÓN </div>
                            </a>
                            <a _ngcontent-c0="" class="c-site-dropdown__link" href="https://www.lexusauto.es/my-lexus/registration/">
                              <div _ngcontent-c0="" class="c-site-dropdown__text"> UNIRSE A MY LEXUS </div>
                            </a>
                            <a _ngcontent-c0="" class="c-site-dropdown__link is--hidden" data-overlay-native-form="true" data-view="responsive/Overlay" href="https://www.lexusauto.es/forms/manuals/owners-manual" id="owner-manuals">
                              <div _ngcontent-c0="" class="c-site-dropdown__text"> MANUAL DE USUARIO </div>
                            </a>
                            <a _ngcontent-c0="" class="c-site-dropdown__link" href="https://www.lexusauto.es/multimedia/onboarding/cy17/">
                              <div _ngcontent-c0="" class="c-site-dropdown__text"> LEXUS CONNECTED </div>
                            </a>
                          </div> */}
                        </li>
                        <li _ngcontent-c0="" class="c-site-tools__item c-site-tools__item" style={{ marginTop: 0, marginLeft: 10 }}>
                          <a _ngcontent-c0="" class="c-site-tools__link js-searchOverlayOpen" href="https://www.lexusauto.es/search" id="site-search" style={{ textDecoration: 'none' }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <img _ngcontent-c0="" src="./images/search-lens.png" style={{ width: 19, height: 19 }} />
                              <span className='tool-link-span'>Buscar</span>
                            </div>
                          </a>
                          <div _ngcontent-c0="" aria-hidden="true" class="c-search-panel js-searchContainer" id="search-container">
                            <form _ngcontent-c0="" action="/search" class="js-searchPanelForm ng-untouched ng-pristine ng-valid" method="GET" novalidate="">
                              <label _ngcontent-c0="" class="c-search-panel__label" for="search-panel">Buscar</label>
                              <button _ngcontent-c0="" class="c-search-panel__button js-searchSubmit" type="submit">
                                <i _ngcontent-c0="" aria-label="Search" class="ui-icon ui-icon--search"></i>
                              </button>
                              <input _ngcontent-c0="" autocomplete="off" class="c-search-panel__input js-searchInput" id="search-panel" name="search_term" placeholder="Empezar a buscar" type="search" />
                              <button _ngcontent-c0="" aria-controls="search-container" aria-expanded="false" class="c-search-panel__button c-search-panel__button--close js-searchOverlayClose">
                                <i _ngcontent-c0="" aria-label="Close" class="ui-icon ui-icon--close  "></i>
                              </button>
                            </form>
                          </div>
                        </li>
                        <li _ngcontent-c0="" class="c-site-tools__item c-site-tools__item c-site-tools__item--burger" style={{ marginTop: 0 }}>
                          <a _ngcontent-c0="" aria-controls="mobile-nav" aria-expanded="false" class="c-site-tools__link js-mobileNavOpenButton" href="#" id="mobile-navigation">
                            <i _ngcontent-c0="" aria-label="Navegación móvil" class="ui-icon ui-icon--menu  "></i>
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="section-header" style={{ marginTop: 30 }}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h1 className="big-title">Calculadora de Mantenimiento</h1>
                <h2 id="header-calcula-el-coste"className="medium-title">Calcula el coste de las operaciones de mantenimiento de tu Lexus</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
